import React from 'react';
import './animate3.less';

const Animate2: React.FC = () => {
    return (
        <div className="c-animate3">
            <div className="bg"></div>
            <div className="bg bg2"></div>
            <div className="bg bg3"></div>
        </div>
    );
};

export default Animate2;
